/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PurchaseSplit
 */
export interface PurchaseSplit {
    /**
     * 
     * @type {number}
     * @memberof PurchaseSplit
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseSplit
     */
    payoutWallet: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseSplit
     */
    amount: string;
}

/**
 * Check if a given object implements the PurchaseSplit interface.
 */
export function instanceOfPurchaseSplit(value: object): value is PurchaseSplit {
    let isInstance = true;
    isInstance = isInstance && "payoutWallet" in value && value["payoutWallet"] !== undefined;
    isInstance = isInstance && "amount" in value && value["amount"] !== undefined;

    return isInstance;
}

export function PurchaseSplitFromJSON(json: any): PurchaseSplit {
    return PurchaseSplitFromJSONTyped(json, false);
}

export function PurchaseSplitFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurchaseSplit {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': !exists(json, 'user_id') ? undefined : json['user_id'],
        'payoutWallet': json['payout_wallet'],
        'amount': json['amount'],
    };
}

export function PurchaseSplitToJSON(value?: PurchaseSplit | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.userId,
        'payout_wallet': value.payoutWallet,
        'amount': value.amount,
    };
}

